import React from 'react';
import './style.scss';

const Footer = () => {
  return (
    <footer>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-8 col-md-8'>
            <a href='' className='logo'>
              <img src='/assets/img/SMEDX.png' alt='' />
            </a>
            <p className='intro'>
              Chủ trì: Vụ Quản lý Doanh nghiệp - Bộ TTTT
              <br />
              Chiến lược và triển khai: CÔNG TY CỔ PHẦN MIMEDIA
              <br />
              Liên hệ 1: 0836 588 999
              <br />
              Liên hệ 2: 0914 992 257
              <br />
              Email: hotro.smedx@gmail.com
              <br />
            </p>
            <ul className='social flex'>
              <li>
                <a
                  href='https://tinnhiemmang.vn/danh-ba-tin-nhiem/smedxvn-1623309411'
                  target='_blank'
                >
                  <img
                    src='https://tinnhiemmang.vn/handle_cert?id=smedx.vn'
                    width='150px'
                    height='auto'
                  />
                </a>
              </li>
            </ul>
          </div>
          <div className='col-lg-2 col-md-2'></div>
          <div className='col-lg-2 col-md-2'>
            <ul className='link right'>
              <li>
                <p style={{ height: '18px' }}></p>
              </li>
              <li>
                <a href='https://aita.gov.vn/' title='' target='_blank'>
                  Cục tin học hóa
                </a>
              </li>
              <li>
                <a href='https://mimedia.vn' title='mimedia.vn'>
                  MiMedia JSC
                </a>
              </li>
              <li>
                <a href='/nen-tang-so' title=''>
                  Nền tảng đồng hành
                </a>
              </li>
              <li>
                <a href='/giai-dap-thac-mac' title=''>
                  Hỗ trợ
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className='footer-copyright'>
        <a>Bản quyền @2021 bởi Cục Tin học hóa</a>
        <a>Bộ Thông tin & Truyền thông</a>
      </div>
    </footer>
  );
};
export default Footer;
